import styled from 'styled-components';

export const Content = styled.div`
  color: #fff;
  margin: 0 0 30px;
  min-height: 140px;
`;

export const Title = styled.div`
  margin: 0 0 10px;
  color: #ccc;
  font-size: 18px;
  line-height: 1;
  display: flex;
  align-items: center;
  div {
    margin-left: 10px;
  }
`;

export const InfoRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 15px;
  margin: 20px 0;
  p {
    text-align: left;
    margin: 0 7px 0 0;
    /* width: 52%; */
  }
  span {
    display: block;
    color: red;
    white-space: nowrap;
    text-align: left;
  }
  div {
    white-space: nowrap;
    color: #ff8322; //#6e6e6e;
    text-align: left;
  }
`;

export const Info = styled.div`
  color: #999;
`;
